import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";
import { ScreenHeader } from "../Layout";
import MenuList from "../MenuList";

class SportTypes extends PureComponent {
  static propTypes = {
    advisor: PropTypes.shape({
      region: PropTypes.number,
      sportType: PropTypes.number,
      sportVariant: PropTypes.number
    }),
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      })
    ).isRequired,
    onSelect: PropTypes.func
  };

  static defaultProps = {
    onSelect: () => {}
  };

  render() {
    const goBackIcon = () => {
      return (
        <Link to="/regions">
          <i className="icon-back" />
        </Link>
      );
    };

    return (
      <div className="screen-container">
        <ScreenHeader title={this.props.t('sportTypes:screen_title')} left={goBackIcon()} />
        <div className="content">
          <MenuList items={this.props.items} onSelect={this.props.onSelect} />
        </div>
      </div>
    );
  }
}

export default withNamespaces(["sportTypes", "common"], { wait: true })(SportTypes)
